import { parseAppMode } from "./app-mode";
import { parseMemberRoles } from "./roles";
import { expectNullable, expectRecord, expectString } from "./schema";
export function parseMemberContext(value, path = "member") {
    const record = expectRecord(value, path);
    return {
        platformUserId: expectString(record.platformUserId, `${path}.platformUserId`),
        appNickname: record.appNickname === undefined
            ? null
            : expectNullable(record.appNickname, expectString, `${path}.appNickname`),
        roles: parseMemberRoles(record.roles, `${path}.roles`),
        memberStatus: expectString(record.memberStatus, `${path}.memberStatus`),
        defaultAppMode: expectNullable(record.defaultAppMode, parseAppMode, `${path}.defaultAppMode`),
        lastUsedAppMode: expectNullable(record.lastUsedAppMode, parseAppMode, `${path}.lastUsedAppMode`)
    };
}
